var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v(" © "+_vm._s(_vm.year)+" Invision Services Limited. Registered in England No.13223149. All Rights Reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }